import { put } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import { setAppLoading } from '../../slices/authTokenSlice'
import { setUpdatedUser } from '../../slices/deliverySlice'
import { setLinksData } from '../../slices/dashboardSlice'
import { generateAllLinks } from '../../../helpers/helperFunctions'


export function* handleGenerateLinks(action) {
  try {
    yield put(setAppLoading(true))

    const products = action.payload

    const _products = JSON.parse(products)

    if (!_products.products) {
      toast.error("Error: Invalid Format")
    } else if (!_products.products.length) {
      toast.error("Error: No products")
    } else {

    //   {
    //   "id": 140342,
    //   "product_tmpl_id": 104100,
    //   "label": "GOLDSTAR SHOES - NORA-03 GREY/WHITE",
    //   "title": "GOLDSTAR SHOES - NORA-03 GREY/WHITE (4)",
    //   "description": "GOLDSTAR SHOES - NORA-03 GREY/WHITE (4)",
    //   "slug": "",
    //   "image": {
    //
    //   },
    //   "created_date": "2026-05-06T08:44:47.736204"
    // }
      const _isDataValid = _products.products.every(p => p.id && p.title && p.slug !== undefined)
      if(_isDataValid){
        yield put(setLinksData(generateAllLinks(_products)));
      }else{
        toast.error("Error: Invalid Format.")
      }



    }


  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(`Error: ${errMsg}`)
  } finally {
    yield put(setAppLoading(false))
  }
}
